import type { Campaign } from "../../shared/types";

export type PitchingRequirementField = "brief" | "currency";

export function missingFieldsToOpenPitching(
    campaign: Pick<Campaign, "details" | "currency">,
): PitchingRequirementField[] {
    const missing: PitchingRequirementField[] = [];
    if (!campaign.details?.trim()) {
        missing.push("brief");
    }
    if (!campaign.currency) {
        missing.push("currency");
    }
    return missing;
}

export function campaignNeedsSettingsBeforePitching(campaign: Campaign) {
    return missingFieldsToOpenPitching(campaign).length > 0;
}

export function pitchingOpenRequirementsCopy(
    missing: PitchingRequirementField[],
): { title: string; description: string } {
    const needsBrief = missing.includes("brief");
    const needsCurrency = missing.includes("currency");
    if (needsBrief && needsCurrency) {
        return {
            title: "Finish required settings",
            description: "A brief and currency are required the first time you open a campaign for pitches.",
        };
    }
    if (needsCurrency) {
        return {
            title: "Set a currency",
            description: "A currency is required the first time you open a campaign for pitches.",
        };
    }
    return {
        title: "Add a brief",
        description: "A brief is required the first time you open a campaign for pitches.",
    };
}
